import { render, staticRenderFns } from "./MtsTebligatGonderList.vue?vue&type=template&id=6b46aa2a"
import script from "./MtsTebligatGonderList.vue?vue&type=script&lang=ts"
export * from "./MtsTebligatGonderList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports